// extracted by mini-css-extract-plugin
export default {"button":"ogjVfh","skin-default":"mImPYK","skinDefault":"mImPYK","skin-transparent":"E9bLrV","skinTransparent":"E9bLrV"};